<!--
 * @Author: wanglidong
 * @Date: 2021-07-21 15:23:45
 * @LastEditTime: 2021-07-23 14:11:42
 * @LastEditors: your name
 * @Description:
 * @FilePath: \jhMobile\src\cmscomponents\audit\audit.vue
 * @nbsg
-->
<template>
  <van-form :show-error="false" ref="formBaseData" v-if="configData.show">
    <div class="publicRow flex-row-center" v-if="formData.actions.length>1">
      <p>审批结论</p>
      <van-radio-group required v-model="nowAction" direction="horizontal">
        <van-radio
          :name="item"
          v-for="(item, index) in formData.actions"
          :key="index"
          @click="changeAction(item)"
          :rules="[{ required: true, message: '请选择审批结论' }]"
        >
          {{ item.name }}
        </van-radio>
        <!-- <van-radio name="1"> 通过 </van-radio>
        <van-radio name="2"> 不通过 </van-radio> -->
      </van-radio-group>
    </div>
    <!-- reportData.auditorIds -->
    <van-field
      v-model="auditorStrs"
      :required="this.baseData.enableSel && !this.baseData.allowNoSelection"
      :label="receiveAttributeName ? receiveAttributeName : '审批人'"
      placeholder="请选择"
      readonly
      clickable
      @click="showAuditDialog"
      v-if="baseData.enableSel"
      :rules="[
        {
          required: this.baseData.enableSel && !this.baseData.allowNoSelection,
          message: '请选择至少一个接收人',
          trigger: 'blur',
        },
      ]"
    />
    <!--  人员选择器 -->
    <van-popup v-model="showAudit" position="bottom" :style="{ width: '100%' }">
      <van-nav-bar
        title="请选择接收人"
        left-text="取消"
        right-text="确定"
        @click-left="onClickLeft"
        @click-right="onClickRight"
      />
      <van-tree-select
        class="tree-select-blue"
        height="55vw"
        :items="selectPeoPleColumns"
        :main-active-index.sync="activeIndex"
        :active-id.sync="PeoPleColumnsIds"
        @click-item="onSelectPeopleConfirm"
      />
    </van-popup>

    <van-field
      v-if="baseData.enableComment"
      v-model="reportData.content"
      name="审批意见"
      type="textarea"
      required
      autosize
      label="审批意见："
      placeholder=""
      :rules="[
        {
          required: true,
          message: '请填写意见',
          trigger: 'blur',
        },
      ]"
    />
    <van-overlay :show="loading">
      <div class="wrapper">
        <van-loading />
      </div>
    </van-overlay>
    <!--附件-->
    <div class="sg-field" v-if="baseData.enableAttach">
      <div class="sg-name">
        {{ configData.text.att ? configData.text.att : "附件" }}
      </div>
      <van-uploader
        v-model="reportData.fileList"
        :delete="removeFile"
        :after-read="beforeUpload"
      >
        <template #default>
          <div class="uploaderDiv">
            <img src="/static/images/public/uploader.png" alt="" />
          </div>
        </template>
      </van-uploader>
    </div>
  </van-form>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "audit",
  props: {
    configData: {
      type: Object,
      default: {
        //  实体基本数据
        baseData: {},
        //  基本请求地址
        urlBase: "",
        //  是否显示
        show: false,
        //  是否冻结选项
        freeze: false,
        //  提交数据成功时的回调函数
        submitCallBack: null,
        //  选择操作时的回调函数
        selActionCallBack: null,
        //  接收人名字（不传也可
        receiveAttributeName: "接收人",
      },
    },
  },
  data: function () {
    const serverBuss = this.$store.state.httpHost.buss;
    return {
      auditorStrs: "",
      selectPeoPleColumns: [],
      PeoPleColumnsIds: [],
      activeIndex: 0,
      showAudit: false,
      loading: false,
      serverBuss: serverBuss,
      //  表数据
      formData: {
        actions: [],
      },
      receiveAttributeName: "接收人",
      //  执行中，控制参数
      baseData: {
        //  是否显示
        show: false,
        //  是否冻结选项
        freeze: false,
        //  基本请求地址
        urlBase: "",
        //  是否允许选人
        enableSel: false,
        //  是否允许不选人
        allowNoSelection: false,
        //  候选人列表
        sel: [],
        //  是否显示附件
        enableAttach: false,
        //  是否强制附件
        forceAttach: false,
        //  是否允许审批意见
        enableComment: false,
        //  是否强制审批意见
        forceComment: false,
        //  提交审批数据请求url
        requestUrl: "",
        //  静默模式
        //  不会弹出任何提示
        silent: false,
        //  标签宽度
        labelWidth: "110px",
        getNextStepUser: false,
      },
      //  当前选择动作代码
      nowAction: null,
      //  执行中，输入参数
      reportData: {
        //  下一步接收人
        auditorIds: [],
        //  提交，审批意见
        content: "",
        //  被操作表单id
        id: "",
        //  附件表
        fileList: [],
        sigFileList: [],
        keySn: [],
        flag: 0,
      },
      //  提交数据成功时的回调函数
      submitCallBack: null,
      //  选择操作时的回调函数
      selActionCallBack: null,
      reportRules: {},
      //  原始数据
      originData: {},
    };
  },
  watch: {
    /**
     * 监听组件配置
     * @param value
     */
    configData(value) {
      console.log("audit组件", value);
      this.nowAction = null;
      this.baseData.enableSel = false;
      this.baseData.enableAttach = false;
      this.baseData.enableComment = false;
      this.baseData.allowNoSelection = false;
      this.reset();
      this.formData = value.baseData;
      this.baseData.urlBase = value.urlBase;
      this.show = value.show;
      this.baseData.silent = value.silent;
      if (value.freeze) {
        this.freeze = true;
      } else {
        this.freeze = false;
      }
      this.receiveAttributeName = value.receiveAttributeName;
      if (value.labelWidth) {
        this.baseData.labelWidth = value.labelWidth;
      } else {
        this.baseData.labelWidth = "110px";
      }
      //  没有动作列表时不显示
      //  提交数据成功时的回调函数
      this.submitCallBack = value.submitCallBack;
      //  选择操作时的回调函数
      this.selActionCallBack = value.selActionCallBack;

      if (value.getNextStepUser != undefined || value.getNextStepUser != null) {
        //质量巡检特殊处理
        if (!value.getNextStepUser) {
          this.dealParam(value.baseData);
        }
      } else {
        this.baseData.requestUrl = "";
        this.baseData.enableSel = false;
        this.baseData.enableComment = false;
        this.arrangeActions(value.baseData);
      }
      this.recieve = value.baseData.recieve;
    },
  },
  methods: {
    //#region 文件（流程中用）
    // 上传文件前
    beforeUpload(data) {
      const { file } = data;
      if (file.size > 2000 * 1024 * 1024) {
        this.$toast("上传文件大小不能超过500M");
        return;
      }
      console.log(file);

      let fd = new FormData();
      fd.append("file", file);
      this.$httpPost(
        `${this.$store.state.httpHost.file}/japi/filesystem/upload?maxFileSize=${file.size}&viewByAnon=true&longLife=false`,
        fd,
        {
          headers: {
            "Content-Type":
              "multipart/form-data; boundary=----WebKitFormBoundaryIOi8qEBAFV1KN25n",
          },
        }
      )
        .then((res) => {
          if (res.data.status === 1) {
            //   name: file.name,
            // size: file.size,
            // url: res.data.link,
            // id: res.data.id,
            const lastFile =
              this.reportData.fileList[this.reportData.fileList.length - 1];
            if (lastFile) {
              lastFile.name = file.name;
              lastFile.size = file.size;
              lastFile.url = res.data.link;
              lastFile.id = res.data.id;
            }
          } else {
            this.$toast(res.data.message);
          }
          this.$emit("watchAuditFile", this.reportData.fileList);
        })
        .catch((res) => {
          console.log("请求出现错误", res);
          this.$toast(this.$route.name + "上传文件前-请求失败");
        });
    },
    // 删除文件时解绑文件
    removeFile(file, fileList) {
      this.reportData.fileList = fileList;
      this.$emit("watchAuditFile", this.reportData.fileList);
    },
    onSelectPeopleConfirm(val) {
      // console.log(val)
      // console.log(this.PeoPleColumnsIds)
      let nameArray = [];
      this.selectPeoPleColumns[0].children.forEach((item, index) => {
        console.log(item);
        this.PeoPleColumnsIds.forEach((i, t) => {
          if (item.id == i) {
            nameArray.push(item.text);
          }
        });
      });
      // console.log(nameArray)
      // console.log(nameArray.join(','));
      this.auditorStrs = nameArray.join(",");
      this.reportData.auditorIds = this.PeoPleColumnsIds;
      // this.formBaseData.handlePeople = nameArray.join(',')
    },
    onClickLeft() {
      this.showAudit = false;
    },
    onClickRight() {
      this.showAudit = false;
    },
    showAuditDialog() {
      this.showAudit = true;
      console.log(this.baseData.sel);
      for (let i = 0; i < this.baseData.sel.length; i++) {
        const item = this.baseData.sel[i];
        item.text = item.name;
      }
      this.selectPeoPleColumns = [
        {
          text: "接收人",
          children: this.baseData.sel,
        },
      ];
    },
    onConfirm(value, index) {
      Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onChange(picker, value, index) {
      Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancel() {
      Toast("取消");
    },
    validator() {
      return true;
    },
    // 获组件中的选择结果
    getNowAction() {
      return this.nowAction;
    },
    dealParam(data) {
      this.baseData.requestUrl = this.serverBuss + data.actions.agree.url;
      this.baseData.enableSel = false;
      this.baseData.enableComment = true;

      this.reportData.id = data.id;
      this.reportData.auditorIds = data.reportAuditUserId.split(",");
    },
    /**
     * 整理动作列表
     */
    arrangeActions(data) {
      let newActionList = [];
      let actionCount = 0;
      for (const actKey in data.actions) {
        let actVal = data.actions[actKey];
        //  按钮被指定加入到审批选项，则加入到列表中
        if (actVal.joinAudit) {
          newActionList.push(JSON.parse(JSON.stringify(actVal)));
          actionCount++;
        }
      }
      //  根据按钮优先级排序
      let sorted = newActionList.sort((a, b) => {
        return a.priority - b.priority;
      });
      data.actions = sorted;
      if (actionCount == 0) {
        this.configData.show = false;
      }
      //  如果按钮数为1默认选中这个动作并触发选择事件
      if (data.actions.length == 1) {
        this.nowAction = data.actions[0];
        this.changeAction(this.nowAction);
      }
      return data;
    },
    /**
     * 点击重新加载组件的配置
     * */
    changeAction(item) {
      console.log("触发了改变");
      this.baseData.requestUrl = this.serverBuss + item.url;
      //  如果需要获取下一步审批人，那么请求下一步审批人
      if (item.needNextStepUser) {
        let requestUrl = `${this.serverBuss}/japi/${this.baseData.urlBase}/getNextStepUser?id=${this.formData.id}`;
        this.$httpGet(requestUrl)
          .then((res) => {
            if (res.data.status == 1) {
              this.originData = res.data.data;
              this.baseData.sel = res.data.data.selection;
              this.baseData.enableSel = !res.data.data.noSelection;
              this.baseData.allowNoSelection = res.data.data.allowNoSelection;
              this.baseData.enableAttach = res.data.data.allowAttachment;
              this.baseData.forceAttach = res.data.data.needAttachmant;
              if(item.name!="上报"){
                this.baseData.enableComment = res.data.data.allowComment;
              }
              this.baseData.forceComment = res.data.data.needComment;
              //  重置已经填写的数据
              this.reset();
              //  自动带出默认审批意见
              // this.reportData.content = item.defaultComment;
              // this.reportData.content = "";
              this.reportData.content = item.defaultComment  || '';
              //  自动选中
              if (res.data.data.autoSeletion) {
                this.autoSel(res.data.data.autoSeletion);
              }
            } else {
              // this.$messageError(res.data.message)
              Toast.fail(res.data.message);
            }
          })
          .catch((e) => {
            console.log("请求出现错误", e);
            // this.$messageError('请求下一步审批数据失败')
            Toast.fail("请求下一步审批数据失败");
          });
      } else {
        this.sel = [];
        this.baseData.enableSel = false;
        this.baseData.allowNoSelection = false;
        this.baseData.enableAttach = item.allowAttach;
        this.baseData.forceAttach = item.forceAttach;
        this.baseData.enableComment = item.allowComment;
        this.baseData.forceComment = item.forceComment;
        //  重置已经填写的数据
        this.reset();
        //  自动带出默认审批意见
        // this.reportData.content = item.defaultComment;
        // this.reportData.content = "";
        this.reportData.content = item.defaultComment  || '';
      }
      if (this.selActionCallBack) {
        try {
          this.selActionCallBack();
        } catch (e) {
          console.log(e);
        }
      }
    },
    /**
     * 自动选中
     *
     * */
    autoSel(ids) {
      this.selectAuditor(ids);
    },
    /**
     * 重新设置待上报的数据
     */
    reset() {
      this.reportData = {
        //  下一步接收人
        auditorIds: [],
        //  提交，审批意见
        content: "",
        //  被操作表单id
        id: this.formData.id,
        //  附件表
        fileList: [],
        flag: 0,
      };
      this.reportRules = {
        auditorIds: [
          {
            required:
              this.baseData.enableSel && !this.baseData.allowNoSelection,
            message: "请选择至少一个接收人",
            trigger: "blur",
          },
        ],
        fileList: [
          {
            required: this.baseData.forceAttach,
            message: "请上传附件",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写意见",
            trigger: "blur",
          },
        ],
      };
    },
    /**
     * 选中人员触发
     * */
    selectAuditor(val) {
      // 这里以后要重新写
      // ····
      // this.reportData.auditorIds = val
      // 不影响其他模块 自动选中暂时注掉
      // for (let i = 0; i < this.baseData.sel.length; i++) {
      //   const item = this.baseData.sel[i];
      //   item.text = item.name;
      // }
      // this.selectPeoPleColumns = [
      //   {
      //     text: "接收人",
      //     children: this.baseData.sel,
      //   },
      // ];
      // this.PeoPleColumnsIds = val;
      // this.onSelectPeopleConfirm();
    },
    /**
     * 执行提交操作
     * 外部指定id提交时，就使用外部指定的id
     */
    submit(callback) {
      this.loading = true;
      if (this.nowAction == null || this.nowAction == "同意") {
        this.reportData.flag = 1;
      }
      if (this.nowAction == "驳回" || this.nowAction == "退回") {
        this.reportData.flag = 2;
      }
      // this.$refs['mainForm'].validate((valid) => {
      //   if (valid) {

      this.$refs.formBaseData
        .validate()
        .then(() => {
          this.resetFile();

          this.$httpPost(this.baseData.requestUrl, this.reportData)
            .then((res) => {
              if (res.data.status == 1) {
                // onEmit.$emit('Ajax')
                if (!this.baseData.silent) {
                  Toast.success("提交成功");
                  this.loading = false;
                  //传父  成功回调
                  this.$emit("successCallBack", true);
                }
                // 回调
                if (callback) {
                  try {
                    callback();
                  } catch (e) {
                    console.log(e);
                  }
                }
                if (this.submitCallBack) {
                  try {
                    this.submitCallBack();
                  } catch (e) {
                    console.log(e);
                  }
                }
              } else {
                // onEmit.$emit('Ajax')
                // this.$messageError(res.data.message)
                Toast.fail(res.data.message);
                this.$ClearTips();
              }
            })
            .catch((e) => {
              this.loading = false;
              // console.log('请求出现错误', e)
              // onEmit.$emit('Ajax')
              console.log("提交报审错误", e);
              // this.$messageError('提交报审错误')
              Toast.fail("提交报审错误");
              this.$ClearTips();
            });
        })
        .catch((err) => {
          this.loading = false;
          this.$ClearTips();
        });
    },
    // 去除file中content
    resetFile() {
      let files = [];
      for (let item of this.reportData.fileList) {
        files.push({
          name: item.name,
          size: item.size,
          url: item.url,
          id: item.id,
        });
      }
      this.reportData.fileList = files;
    },
    //  将本组件数据写回到指定变量，如果某些模块需要立即上报的话
    pushback(val) {
      val.auditRO = this.reportData;
      val.auditRO.selection = this.originData;
    },
    // 查看文件
    checkFile(file) {
      this.$httpPost(
        this.$store.state.httpHost.file +
          `/japi/filesystem/getFilePreview?id=${file.id}&browserType=1`
      )
        .then((res) => {
          if (res.data.status === 1) {
            // window.open(
            //   res.data.url.replace('/file', this.$store.state.httpHost.file)
            // )
            window.location.href = res.data.url.replace(
              "/file",
              this.$store.state.httpHost.file
            );
          } else if (res.data.status === 0) {
            // this.$messageError(res.data.message)
            Toast.fail(res.data.message);
          } else {
            // this.$messageError('在线预览失败 ')
            Toast.fail("在线预览失败");
          } // window.location.href = res.data.url
        })
        .catch((res) => {
          console.log("请求出现错误", res);
          this.$toast("请求失败!");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.sg-field {
  position: relative;
  margin: 0 15px;
  padding: 15px 0;
  border-bottom: 1px solid rgba(220, 222, 225, 1);
  display: flex;
  .sg-name {
    line-height: 30px;
    height: 30px;
    font-size: 14px;
    font-weight: bold;
    color: #222222;
    span {
      font-size: 13px;
      font-weight: bold;
      color: rgba(153, 153, 153, 1);
    }
  }
  .required:after {
    content: " *";
    color: red;
    font-size: 150%;
  }
  .sg-text {
  }
  input {
    border: none;
    line-height: 32px;
    width: calc(100% - 18px);
    padding: 0;
  }
  img {
    position: absolute;
  }
  .sg-zt {
    bottom: 18px;
    right: 0px;
    width: 14px;
    height: 14px;
    margin: 0 0 4px 0;
  }

  .sg-add {
    width: 20px;
    height: 20px;
    top: 20px;
    right: 0;
  }
}
.uploaderDiv {
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 60px;
    height: 60px;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/cmscomponents/audit/audit.vue